<template>
    <div>
        <v-btn color="primary" small block @click="logout">Päätä istunto/kirjaudu ulos</v-btn>
        <v-overflow-btn
        class="my-2"
        :items="availLists"
        v-model="selectedList"
        label="Valitse lista"
        ></v-overflow-btn>
    </div>
</template>
<script>
import store from "@/store"

export default {
    data() {
        return {
            availLists: [
                { text: 'Kiuruveden koulut', value: '730' },
                { text: 'YSAO', value: '810' }
            ],
        }
    },
    computed: {
        selectedList: {
        get() { return store.getters.placeid },
        set(val) { store.dispatch('savePlaceid', val); this.$router.go() }
        }
    },
    methods: {
        logout() {
            localStorage.clear()
            location.reload('/')
        }
    }
}
</script>